"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarehouseBrief = exports.IC2Digest = exports.IC2 = exports.IC2ServicingC1 = exports.ISkubanaCreds = exports.IServicingC1 = exports.IWarehouseMap = exports.IWarehouseInfo = exports.INetwork = exports.IOrgUserRole = exports.IRole = exports.AssemblyList_Ext = exports.ItemsSummary = exports.Assembly_Ext = exports.AdjustmentList_Ext = exports.Adjustment_Ext = exports.ReceiverDigestList_Ext = exports.ReceiverDigest_Ext = exports.OrderDigestList_Ext = exports.OrderDigest_Ext = exports.ProductStock_Ext = exports.StockLocation2_Ext = void 0;
const openapi_1 = require("../../openapi");
const skubana_1 = require("../../skubana");
const wms_1 = require("../../wms");
class StockLocation2_Ext extends skubana_1.StockLocation2 {
    warehouseName;
    c2OrgKey;
    sc1OrgKey;
}
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], StockLocation2_Ext.prototype, "warehouseName", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], StockLocation2_Ext.prototype, "c2OrgKey", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], StockLocation2_Ext.prototype, "sc1OrgKey", void 0);
exports.StockLocation2_Ext = StockLocation2_Ext;
class ProductStock_Ext extends skubana_1.ProductStock {
}
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)(() => StockLocation2_Ext)
], ProductStock_Ext.prototype, "stockLocation", void 0);
exports.ProductStock_Ext = ProductStock_Ext;
class OrderDigest_Ext extends wms_1.WMS.V2.Order.Models.OrderDigest {
    Sc1OrgKey;
    OrderItemInfosSummary;
}
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], OrderDigest_Ext.prototype, "Sc1OrgKey", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)(() => ItemsSummary)
], OrderDigest_Ext.prototype, "OrderItemInfosSummary", void 0);
exports.OrderDigest_Ext = OrderDigest_Ext;
class OrderDigestList_Ext extends wms_1.WMS.V2.Order.Models.OrderDigestList {
}
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'array', items: (0, openapi_1.ref)(() => ReceiverDigest_Ext) })
], OrderDigestList_Ext.prototype, "ResourceList", void 0);
exports.OrderDigestList_Ext = OrderDigestList_Ext;
class ReceiverDigest_Ext extends wms_1.WMS.V2.Inventory.Models.ReceiverDigest {
    Sc1OrgKey;
    ReceiveItemInfosSummary;
}
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], ReceiverDigest_Ext.prototype, "Sc1OrgKey", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)(() => ItemsSummary)
], ReceiverDigest_Ext.prototype, "ReceiveItemInfosSummary", void 0);
exports.ReceiverDigest_Ext = ReceiverDigest_Ext;
class ReceiverDigestList_Ext extends wms_1.WMS.V2.Inventory.Models
    .ReceiverDigestList {
}
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'array', items: (0, openapi_1.ref)(() => ReceiverDigest_Ext) })
], ReceiverDigestList_Ext.prototype, "ResourceList", void 0);
exports.ReceiverDigestList_Ext = ReceiverDigestList_Ext;
class Adjustment_Ext extends wms_1.WMS.V2.Inventory.Models.Adjustment {
    Sc1OrgKey;
    AdjustmentItemInfosSummary;
}
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], Adjustment_Ext.prototype, "Sc1OrgKey", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)(() => ItemsSummary)
], Adjustment_Ext.prototype, "AdjustmentItemInfosSummary", void 0);
exports.Adjustment_Ext = Adjustment_Ext;
class AdjustmentList_Ext extends wms_1.WMS.V2.Inventory.Models.AdjustmentList {
}
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'array', items: (0, openapi_1.ref)(() => Adjustment_Ext) })
], AdjustmentList_Ext.prototype, "ResourceList", void 0);
exports.AdjustmentList_Ext = AdjustmentList_Ext;
class Assembly_Ext extends wms_1.WMS.V2.Inventory.Models.Assembly {
    Sc1OrgKey;
    AssemblyItemInfosSummary;
}
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], Assembly_Ext.prototype, "Sc1OrgKey", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)(() => ItemsSummary)
], Assembly_Ext.prototype, "AssemblyItemInfosSummary", void 0);
exports.Assembly_Ext = Assembly_Ext;
class ItemsSummary {
    TotalPrimaryInvQty;
    TotalAvailable;
    TotalItems;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'integer' })
], ItemsSummary.prototype, "TotalPrimaryInvQty", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'integer' })
], ItemsSummary.prototype, "TotalAvailable", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'integer' })
], ItemsSummary.prototype, "TotalItems", void 0);
exports.ItemsSummary = ItemsSummary;
class AssemblyList_Ext extends wms_1.WMS.V2.Inventory.Models.AssemblyList {
}
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'array', items: (0, openapi_1.ref)(() => Assembly_Ext) })
], AssemblyList_Ext.prototype, "ResourceList", void 0);
exports.AssemblyList_Ext = AssemblyList_Ext;
class IRole {
    id;
    orgKey;
    name;
    description;
    creationdate;
    permissions;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], IRole.prototype, "id", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], IRole.prototype, "orgKey", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IRole.prototype, "name", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], IRole.prototype, "description", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'integer' })
], IRole.prototype, "creationdate", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'array', items: { type: 'string' } })
], IRole.prototype, "permissions", void 0);
exports.IRole = IRole;
class IOrgUserRole {
    orgKey;
    userId;
    roleId;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], IOrgUserRole.prototype, "orgKey", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], IOrgUserRole.prototype, "userId", void 0);
__decorate([
    (0, openapi_1.Schema)({
        type: 'string',
        format: 'uuid',
        description: "ID of the user's role",
    })
], IOrgUserRole.prototype, "roleId", void 0);
exports.IOrgUserRole = IOrgUserRole;
class INetwork {
    orgKey;
    name;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], INetwork.prototype, "orgKey", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], INetwork.prototype, "name", void 0);
exports.INetwork = INetwork;
class IWarehouseInfo {
    warehouseId;
    alias;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'integer', description: 'ID of this warehouse in 3W' })
], IWarehouseInfo.prototype, "warehouseId", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string', description: 'Alternative name for display' })
], IWarehouseInfo.prototype, "alias", void 0);
exports.IWarehouseInfo = IWarehouseInfo;
class IWarehouseMap {
    wmsWarehouseId;
    skubanaWarehouseId;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'integer', description: 'ID of this warehouse in 3W' })
], IWarehouseMap.prototype, "wmsWarehouseId", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'integer', description: 'ID of this warehouse in OM' })
], IWarehouseMap.prototype, "skubanaWarehouseId", void 0);
exports.IWarehouseMap = IWarehouseMap;
class IServicingC1 {
    netOrgKey;
    orgKey;
    tplGuid;
    warehouses;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], IServicingC1.prototype, "netOrgKey", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], IServicingC1.prototype, "orgKey", void 0);
__decorate([
    (0, openapi_1.Schema)({
        type: 'string',
        format: 'uuid',
        description: 'GUID of this Servicing C1 in 3W',
    })
], IServicingC1.prototype, "tplGuid", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'array', items: (0, openapi_1.ref)(() => IWarehouseInfo) })
], IServicingC1.prototype, "warehouses", void 0);
exports.IServicingC1 = IServicingC1;
class ISkubanaCreds {
    clientId;
    clientSecret;
    accessToken;
    refreshToken;
}
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], ISkubanaCreds.prototype, "clientId", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], ISkubanaCreds.prototype, "clientSecret", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], ISkubanaCreds.prototype, "accessToken", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({ type: 'string' })
], ISkubanaCreds.prototype, "refreshToken", void 0);
exports.ISkubanaCreds = ISkubanaCreds;
class IC2ServicingC1 {
    orgKey;
    customerId;
    warehouses;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], IC2ServicingC1.prototype, "orgKey", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'integer' })
], IC2ServicingC1.prototype, "customerId", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'array', items: (0, openapi_1.ref)(() => IWarehouseMap) })
], IC2ServicingC1.prototype, "warehouses", void 0);
exports.IC2ServicingC1 = IC2ServicingC1;
class IC2 {
    netOrgKey;
    orgKey;
    skubanaCreds;
    srvC1s;
    customerIdInOwningC1;
    isBillingEnabled;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], IC2.prototype, "netOrgKey", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], IC2.prototype, "orgKey", void 0);
__decorate([
    (0, openapi_1.Schema)(() => ISkubanaCreds)
], IC2.prototype, "skubanaCreds", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'array', items: (0, openapi_1.ref)(() => IC2ServicingC1) })
], IC2.prototype, "srvC1s", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({
        type: 'integer',
        description: 'Owning C1s ID for this customer in 3W',
    })
], IC2.prototype, "customerIdInOwningC1", void 0);
__decorate([
    (0, openapi_1.Optional)(),
    (0, openapi_1.Schema)({
        type: 'boolean',
        description: 'This C2 is enabled to be billed',
    })
], IC2.prototype, "isBillingEnabled", void 0);
exports.IC2 = IC2;
class IC2Digest {
    netOrgKey;
    orgKey;
    srvC1s;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], IC2Digest.prototype, "netOrgKey", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string', format: 'uuid' })
], IC2Digest.prototype, "orgKey", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'array', items: (0, openapi_1.ref)(() => IC2ServicingC1) })
], IC2Digest.prototype, "srvC1s", void 0);
exports.IC2Digest = IC2Digest;
class WarehouseBrief {
    id;
    name;
}
__decorate([
    (0, openapi_1.Schema)({ type: 'integer', description: 'ID of this warehouse in 3W' })
], WarehouseBrief.prototype, "id", void 0);
__decorate([
    (0, openapi_1.Schema)({ type: 'string' })
], WarehouseBrief.prototype, "name", void 0);
exports.WarehouseBrief = WarehouseBrief;
